"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberAdditionalTextInput = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../models");
var ErrorMessage_1 = require("../ErrorMessage");
var Input_1 = require("../Input");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var Text = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.5;\n  font-size: 16px;\n  color: ", ";\n  word-break: break-all;\n"], ["\n  line-height: 1.5;\n  font-size: 16px;\n  color: ", ";\n  word-break: break-all;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var WIDTH_UNIT = 'px';
var InputWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 100%;\n  width: ", ";\n  display: inline-block;\n  min-width: 90px;\n  vertical-align: middle;\n"], ["\n  max-width: 100%;\n  width: ", ";\n  display: inline-block;\n  min-width: 90px;\n  vertical-align: middle;\n"])), function (_a) {
    var width = _a.width;
    return "".concat(width).concat(WIDTH_UNIT);
});
var NumberAdditionalTextInput = function (_a) {
    var propertyId = _a.propertyId, placeholder = _a.placeholder, onChange = _a.onChange, onBlur = _a.onBlur, value = _a.value, errorMessages = _a.errorMessages, disabled = _a.disabled, design = _a.design, className = _a.className, _b = _a.width, width = _b === void 0 ? 316 : _b, _c = _a.before, before = _c === void 0 ? '' : _c, _d = _a.after, after = _d === void 0 ? '' : _d, displayError = _a.displayError, _e = _a.password, password = _e === void 0 ? false : _e;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    var handleBlur = function (e) {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    var inputFont = design.colors.inputFont;
    return (react_1.default.createElement(PropertyInputWrapper_1.PropertyInputWrapper, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.number, inputFormatType: models_1.NUMBER_PROPERTY_INPUT_TYPE.additionalText, errorMessages: errorMessages, className: className, displayError: displayError },
        react_1.default.createElement("div", null,
            before && (react_1.default.createElement(Text, { color: inputFont, style: { marginRight: '8px' }, dangerouslySetInnerHTML: {
                    __html: before,
                } })),
            react_1.default.createElement(InputWrapper, { width: width },
                react_1.default.createElement(Input_1.Input, { "data-cy-property-item": true, error: displayError, value: value, type: password ? 'password' : 'text', placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, disabled: disabled, name: propertyId, id: propertyId, "aria-invalid": displayError, "aria-errormessage": (0, ErrorMessage_1.getFieldErrorMessageId)(propertyId) })),
            after && (react_1.default.createElement(Text, { color: inputFont, style: { marginLeft: '8px' }, dangerouslySetInnerHTML: {
                    __html: after,
                } })))));
};
exports.NumberAdditionalTextInput = NumberAdditionalTextInput;
var templateObject_1, templateObject_2;
